var _g, _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 71,
    viewBox: "0 0 67 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_485_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.42 2.42375C24.0432 6.78332 19.6349 13.6455 18.4749 21.0175L18.1261 23.2347L16.5983 24.4101C10.8343 28.8456 6.81388 35.8478 5.81867 43.1855C5.37103 46.4862 5.43885 47.5919 6.15419 48.6613C7.40603 50.5324 13.0651 52.7833 17.9824 53.3661C22.5438 53.9067 28.1857 53.1504 31.8463 51.5077L33.4214 50.8007L36.0536 51.7865C43.5469 54.5933 52.165 54.1254 58.7583 50.5543C61.0599 49.3077 61.4453 48.6948 61.4453 46.2789C61.4453 38.4226 57.5325 30.1932 51.4793 25.3181C50.3373 24.3985 49.3263 23.5065 49.2325 23.336C49.1389 23.1655 48.9839 22.237 48.8884 21.2731C48.6813 19.1827 47.4325 15.3275 46.1198 12.7247C44.7514 10.0112 41.9158 6.38884 39.6978 4.52021C34.817 0.408126 33.7279 0.162022 30.42 2.42375ZM36.5439 10.3608C37.853 11.6932 39.359 13.5306 39.8902 14.4441C40.9098 16.1968 42.3693 19.7244 42.1614 19.9326C42.0938 20.0002 41.0795 19.7942 39.9074 19.475C37.0626 18.7002 30.1014 18.6401 27.4933 19.3679C26.5576 19.6289 25.6521 19.8424 25.481 19.8424C24.7372 19.8424 26.0704 16.6773 28.1273 13.5599C29.6266 11.2874 32.9771 7.93855 33.7512 7.93855C33.9779 7.93855 35.2344 9.02872 36.5439 10.3608ZM37.9145 25.4967C38.9041 25.7082 40.4428 26.1558 41.3339 26.4911L42.9536 27.101L42.7599 28.6515C42.3358 32.0471 40.3694 36.4549 37.9324 39.4743C36.9298 40.7162 33.9167 43.3732 33.5109 43.3732C33.3885 43.3732 32.4481 42.6031 31.4208 41.6618C29.1278 39.561 27.1465 36.7882 26.0544 34.1522C25.1358 31.935 24.1813 27.878 24.4274 27.2369C24.5938 26.8034 27.242 25.8173 29.3517 25.4034C31.2857 25.0242 35.9417 25.0748 37.9145 25.4967ZM19.5466 34.6455C20.5999 37.9622 22.7587 41.6569 25.1632 44.258L27.1326 46.3882L26.087 46.6905C25.512 46.8566 23.7337 47.0629 22.1349 47.149C18.9104 47.3223 16.4709 46.9369 13.6633 45.8102L12.0305 45.1549L12.1086 43.918C12.3306 40.3912 14.8158 35.045 17.676 31.9394C18.5001 31.0447 18.3202 30.7845 19.5466 34.6455ZM52.147 35.5818C53.3346 37.537 54.7465 41.6607 54.9743 43.84L55.1437 45.4597L52.8269 46.2603C50.8786 46.9339 49.9462 47.0811 46.9597 47.1883C43.7792 47.3023 40.1291 46.9275 40.1291 46.4868C40.1291 46.4137 40.8148 45.6131 41.6531 44.7078C44.5191 41.6123 47.0051 37.2671 48.1974 33.2699L48.7749 31.3332L49.9772 32.6612C50.6385 33.3914 51.6149 34.7058 52.147 35.5818Z",
    fill: "url(#paint0_linear_485_1096)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.497,
    cy: 62.7343,
    r: 7.4745,
    fill: "#6FD4F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9657,
    cy: 18.7167,
    r: 7.4745,
    fill: "#46C0FD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.4745,
    cy: 18.7167,
    r: 7.4745,
    fill: "#5C9DD8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_485_1096",
    x: 3.53711,
    y: 0,
    width: 59.9082,
    height: 56.6045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_485_1096"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_485_1096",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_485_1096",
    x1: 5.53711,
    y1: 31.4517,
    x2: 57.3049,
    y2: 31.1748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.394097,
    stopColor: "#6486EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836805,
    stopColor: "#20BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987847,
    stopColor: "#5CD7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFav);
export default __webpack_public_path__ + "static/media/logoFav.4fd6577f3ec452e3688b0e66f94f3434.svg";
export { ForwardRef as ReactComponent };